/*!--------------------------------------------------------------------------
// <copyright file="GSS.portal.js" company="Gallup" product="GSS" owner="All">
//    Copyright (c) The Gallup Organization. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------*/
/* Remarks: This file is used to override base jquery functionality. */
$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    // <summary>Prefilters the data for an ajax request.</summary>
    var _success = options.success;
    options.success = function (data, textStatus, jqXHR) {
        // Check to see if an error has occured (but is received as a success)
        // and needs to be handled globally.
        if (HandleAjaxError(jqXHR)) {
            return;
        }
        // override success handling
        if (typeof (_success) === "function")
            return _success(data, textStatus, jqXHR);
    };
    var _error = options.error;
    options.error = function (jqXHR, textStatus, errorThrown) {
        if ((_error !== undefined) && (_error !== null)) {
            // Check to see if the error needs to be handled globally.
            if (HandleAjaxError(jqXHR)) {
                return _error(jqXHR, "", errorThrown);
            }
            // override error handling
            if (typeof (_error) === "function")
                return _error(jqXHR, textStatus, errorThrown);
        }
    };
    function HandleAjaxError(jqXHR) {
        // This tests for various security permission scenarios that may arise
        // due to a session timeout or logout (from another tab).
        if (jqXHR && jqXHR.status === 401) {
            var _location = window.location.href;
            var _hash = window.location.hash;
            var _delimeter = _location.indexOf('?') > -1 ? '&' : '?';
            window.location.href = _location.replace(_hash, '') + _delimeter + 'unAuthRedirect=' + new Date().getTime() + _hash;
            return true;
        }
        return false;
    }
});
//# sourceMappingURL=GSS.jquery.js.map